import React, { Fragment, useState, useEffect } from 'react';
import styles from './styles.scss';
import { useParams } from 'react-router-dom';

import MultiPointInstallationCreationStore from '../../../rx-stores/multi-point-installation-creation';
import {
  MultiPointInstallationCreationAction,
  MultiPointInstallationCreationActionTypes,
} from '../../../types/multi-point-installation-creation';

import useRxStore from '../../../utils/use-rx-store';
import useRxDispatch from '../../../utils/use-rx-dispatch';

import {
  AppBar,
  AppBarContext,
  AppBarTitle,
  AppBarSection,
  Button,
  InputBox,
} from '@densityco/ui';
import Modal from '../../Modal';
import FormLabel from '../../FormLabel';
import HorizontalForm from '../../HorizontalForm';

const MultiPointInstallationCreationModal: React.FunctionComponent<{
  open: boolean;
  onDismiss: () => void;

  sensors: Array<{ serialNumber: string; doorwayName: string }>;
}> = ({ open, onDismiss, sensors }) => {
  const state = useRxStore(MultiPointInstallationCreationStore);
  const dispatch = useRxDispatch();
  const { organizationIdOrAll } = useParams();

  useEffect(() => {
    if (open) {
      dispatch({
        type:
          MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_OPEN,
        sensors,
      });
    }
  }, [open]);

  return (
    <Modal visible={open} onBlur={onDismiss} onEscape={onDismiss}>
      <div className={styles.wrapper} data-test-id="mpi-creation-modal">
        <AppBar>
          <AppBarTitle>Configuration Details</AppBarTitle>
        </AppBar>

        <div className={styles.body}>
          <FormLabel
            label="Name"
            htmlFor="creationName"
            input={
              <InputBox
                type="text"
                id="creationName"
                placeholder={'ex: "Main Entry", "Stairwell A"'}
                width="100%"
                value={state.setup.name}
                onChange={e =>
                  dispatch({
                    type:
                      MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_SETUP_SET_NAME,
                    name: e.target.value,
                  })
                }
                data-test-id="mpi-creation-modal-name"
              />
            }
          />
          <FormLabel
            label="Height"
            htmlFor="creationHeight"
            input={
              <InputBox
                type="text"
                placeholder="ex: 120 inches"
                width="100%"
                id="creationHeight"
                value={state.setup.height}
                onChange={e =>
                  dispatch({
                    type:
                      MultiPointInstallationCreationActionTypes.MULTI_POINT_INSTALLATION_CREATION_SETUP_SET_HEIGHT,
                    height: e.target.value,
                  })
                }
                data-test-id="mpi-creation-modal-height"
              />
            }
          />
        </div>

        <AppBarContext.Provider value="BOTTOM_ACTIONS">
          <AppBar>
            <AppBarSection />
            <AppBarSection>
              <HorizontalForm>
                <Button variant="underline" onClick={() => onDismiss()}>
                  Cancel
                </Button>

                <Button
                  variant="filled"
                  onClick={() => {
                    window.location.href = `#/${organizationIdOrAll}/multi-point-installations/creation-step-reorder`;
                  }}
                  disabled={
                    !(
                      state.setup.name.length > 0 &&
                      state.setup.height.length > 0 &&
                      !isNaN(parseFloat(state.setup.height))
                    )
                  }
                  data-test-id="mpi-creation-modal-next-button"
                >
                  Next Step
                </Button>
              </HorizontalForm>
            </AppBarSection>
          </AppBar>
        </AppBarContext.Provider>
      </div>
    </Modal>
  );
};

export default MultiPointInstallationCreationModal;
